import React from 'react';
import PropTypes from 'prop-types';
import { router, routerRedux } from 'dva';
import dynamic from 'dva/dynamic';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import App from './routes/app';
import Company from './routes/company';
import CompanyDetail from './routes/company/detail';
import LocalActivity from './routes/localActivity';
import ThemeDayActivity from './routes/themeDayActivity';
import Topic from './routes/topic';
import TopicDetail from './routes/topic/detail';
import Home from './routes/home';
import Info from './routes/info';
import Activity from './routes/activitySchedule'
import Forum from './routes/forum';
// import ForumDetail from './routes/forum/detail';

import News from './routes/news';
import NewsDetail from './routes/newsDetail';
import CloudClassroom from './routes/cloudClassroom';
import CloudClassroomDetail from './routes/cloudClassroomDetail';
import ForumList from './routes/forumList';
import ForumDetail from './routes/forumDetail';

const {
  Switch, Route,
  Redirect,
} = router;

const { ConnectedRouter } = routerRedux;

moment.locale('zh-cn');
interface IRoutersProps {
  history: any;
  app: any;
}

const Routers: React.FC<IRoutersProps> = ({ history, app }) => {
  const error = dynamic({
    app,
    component: () => import('./routes/error'),
  } as any);
  const routes: any = [
    // {
    //   path: '/app/file',
    //   component: () => import('./routes/file'),
    // },
  ];

  return (
    <ConfigProvider locale={zhCN}>
      <ConnectedRouter history={history}>
        <App>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/app/home" />} />
            <Route exact path="/app/home" render={() => <Home />} />

            {/* 新闻动态   1 各地新闻  2 主题日新闻 */}
            <Route exact path="/app/newsList/:type" render={() => <News />} />
            {/* 新闻详情 */}
            <Route exact path="/app/newsDetail/:id" render={() => <NewsDetail />} />
            {/* 网络安全云课堂 */}
            <Route exact path="/app/cloudClassroom" render={() => <CloudClassroom />} />
            {/* 云课堂详情 */}
            <Route exact path="/app/cloudClassroomDetail/:id" render={() => <CloudClassroomDetail />} />
            {/* 论坛列表 */}
            <Route exact path="/app/ForumList" render={() => <ForumList />} />
            {/* 论坛详情 */}
            <Route exact path="/app/ForumDetail/:id" render={() => <ForumDetail />} />

            <Route exact path="/app/activitySchedule" render={() => <Activity />} />
            <Route exact path="/app/company" render={() => <Company />} />
            <Route exact path="/app/company/:id" render={() => <CompanyDetail/>} />
            <Route exact path="/app/theme" render={() => <ForumDetail />} />
            <Route exact path="/app/forum" render={() => <Forum />} />
            <Route exact path="/app/forum/detail/:id" render={() => <ForumDetail />} />
            <Route exact path="/app/info" render={() => <Info />} />
            <Route exact path="/app/localActivity" render={() => <LocalActivity />} />
            <Route exact path="/app/themeDayActivity" render={() => <ThemeDayActivity />} />
            <Route exact path="/app/topic/:index" render={() => <Topic />} />
            <Route exact path="/app/topic/detail/:id" render={() => <TopicDetail />} />
            {routes.map(({ path, exact, ...dynamics }: any) => (
              <Route
                key={path}
                exact={exact !== false}
                path={path}
                component={dynamic({
                  app,
                  ...dynamics,
                } as any) as any}
              />
            ))}
            <Route component={error as any} />
          </Switch>
        </App>
      </ConnectedRouter>
    </ConfigProvider>
  );
};

Routers.propTypes = {
  history: PropTypes.object,
  app: PropTypes.object,
};

export default Routers;
